import {useEffect, useState} from 'react';

interface UseDebounceOptions {
  delay?: number;
}

export const useDebounce = <T>(value: T, {delay = 300}: UseDebounceOptions = {}) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return [debouncedValue];
};
